import React, {Component} from 'react';
import { loadQuickPostings, getAPI, setRound, AuthenticatedUser, putToast, stopTimer } from "../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from './tournamentPageTemplate'
import ReactHtmlParser from "react-html-parser";
import {CSVLink} from "react-csv";
const moment = require("moment");

class TournamentQuickPostings extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onRoundSet = this.onRoundSet.bind(this);
        this.getTdProps = this.getTdProps.bind(this);
        this.buildCSV = this.buildCSV.bind(this);

        this.state = {
            loading: true,
            open: false,
            user: user,
            selectedRound: null,
            tData: {},
            pid: params.pid
        }

    }
    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            loadQuickPostings(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ tData: d2.tournamentPage, loading: false}); 
                    this.getBuiltAnalysis(this.state.pid)                  
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "delete") {
            return {
                onClick: () => { 
                    this.setState({ selectedRound: rowInfo.original})
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }

    onRoundSet = (newState) => {
        // TODO: enable for testing
        if (newState === 'fakeballots') return;
        
        setRound(this.state.tData._id, newState).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
                putToast.error(d2.error);
            } else {
                putToast.success(d2.message);

                this.setState({ tData: d2.tournamentPage});  
                if (newState === 'building') this.getBuiltAnalysis(this.state.pid);                
                if (newState === 'fakeballots') this.getBallotAnalysis(this.state.pid);                
            }
        });
    };

    getBuiltAnalysis(pid) {
        getAPI(`built/analyze/${pid}`)
        .then(result => {
            this.setState({ builtData: result.data, schedule: result.schedule})
        })
    }

    getBallotAnalysis(pid) {
        getAPI(`ballot/analyze/${pid}`)
        .then(result => {
            this.setState({ ballotData: result.data})
        })
    }

    buildCSV() {
        const currentRecords = this.reactTable.getResolvedState().sortedData;
        var data_to_download = []
        for (var index = 0; index < currentRecords.length; index++) {
            let record_to_download = {}
            for(var colIndex = 0; colIndex < this.buildColumns.length ; colIndex ++) {
                if(colIndex === 2) {
                    var value = currentRecords[index][this.buildColumns[colIndex].accessor];
                    value = value.substring('<a target=_blank" rel="noopener noreferrer" href='.length+1);
                    value = value.substring(0,value.length - 4)
                    var i = value.indexOf(">");
                    var roomNumber = value.substring(i+1);
                    value = value.substring(0,i);
                    record_to_download[this.buildColumns[colIndex].Header] = `${roomNumber}: ${value}`;
                } else record_to_download[this.buildColumns[colIndex].Header] = currentRecords[index][this.buildColumns[colIndex].accessor]
            }
            data_to_download.push(record_to_download)
        }

        this.setState({ dataToDownload: data_to_download}, () => {
            // click the CSVLink component to trigger the CSV download
            this.csvLink.link.click()
        })       
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user } = this.state;
            this.buildColumns = [
                { Header: 'Round', accessor: 'round', maxWidth: 150},
                { Header: 'Event', accessor: 'event', maxWidth: 250},
                { Header: 'Room', accessor: 'room', maxWidth: 150,
                Cell:  (props) => { return ReactHtmlParser(props.value)}}
            ]
            if (this.state.builtData && this.state.builtData.find(x=>x.B)) {
                this.buildColumns.push({ Header: 'Aff/Gov/Pet', accessor: 'A', maxWidth: 220 });
                this.buildColumns.push({ Header: 'Neg/Opp/Res', accessor: 'B', maxWidth: 220 });
            } else {
                this.buildColumns.push({ Header: 'Speakers', accessor: 'A', maxWidth: 440 });
            }
            this.buildColumns.push({ Header: 'Judges', accessor: 'jud' })
            
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Posting Summary - ${user.displayname}`} title3=""
                bcTitle="Posting" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                ]}
            >                
                    <div className="container-fluid">           
                        {this.state.builtData &&                        
                        <div className="row">
                            <div className="col-sm-12">
                            <hr />
                                <h3 style={{marginLeft: "20px", display: "inline"}}>Build Results</h3>
                                <CSVLink style={{marginLeft: "20px", display: "inline"}}
                                    data={this.state.dataToDownload ? this.state.dataToDownload : ""}
                                    filename={`build_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                                    className="hidden"
                                    ref={(r) => this.csvLink = r}
                                    target="_blank"
                                />
                                <button style={{marginLeft: "20px", display: "inline"}} type="button" className="btn btn-primary" onClick={this.buildCSV}>Download</button>
                                
                                <ReactTable ref={(r) => this.reactTable = r}
                                    filterable
                                    defaultFilterMethod={ (filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }}
                                    data={this.state.builtData}
                                    columns={this.buildColumns}                                        
                                    pageSize={(this.state.builtData.length > 50) ? 50 : this.state.builtData.length}
                                    showPagination={(this.state.builtData.length > 50)}                    
                                    defaultPageSize={50}                                         
                                />
                            </div>
                        </div>                                            
                        }                                            
                            
                    </div> 

                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentQuickPostings;